var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 93,
    viewBox: "0 0 92 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 0.0844727C20.6356 0.0844727 0 20.7201 0 46.0845V65.1423C0 69.8527 4.1262 73.6845 9.2 73.6845H13.8C15.02 73.6845 16.19 73.1998 17.0527 72.3372C17.9154 71.4745 18.4 70.3045 18.4 69.0845V45.4267C18.4 44.2067 17.9154 43.0366 17.0527 42.174C16.19 41.3113 15.02 40.8267 13.8 40.8267H9.6232C12.1808 23.0247 27.4988 9.28447 46 9.28447C64.5012 9.28447 79.8192 23.0247 82.3768 40.8267H78.2C76.98 40.8267 75.81 41.3113 74.9473 42.174C74.0846 43.0366 73.6 44.2067 73.6 45.4267V73.6845C73.6 78.7583 69.4738 82.8845 64.4 82.8845H55.2V78.2845H36.8V92.0845H64.4C74.5476 92.0845 82.8 83.8321 82.8 73.6845C87.8738 73.6845 92 69.8527 92 65.1423V46.0845C92 20.7201 71.3644 0.0844727 46 0.0844727Z",
    fill: "url(#paint0_linear_1_171)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_171",
    x1: -21.7634,
    y1: 92.0845,
    x2: 203.043,
    y2: 92.0845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.bdf9c69450957ba4a6a2a78241f64eda.svg";
export { ForwardRef as ReactComponent };